
import React from "react";

interface ArchiveIconProps {
  className?: string;
  size?: number;
}

const ArchiveIcon: React.FC<ArchiveIconProps> = ({ 
  className = "", 
  size = 18
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 18 18" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect 
        x="2" 
        y="2" 
        width="14" 
        height="14" 
        rx="2" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        fill="none"
      />
      <path 
        d="M4 6.5H14" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ArchiveIcon;
